import api from 'Plugins/api'
import Bussiness from 'Utils/business'
import Train from '../entities/train'
import InsuranceInteractor from './insurance-interactor'

import { formatDate, getDiffDays, getDiffHours, getDiffMinutes, trimStrTimehm } from 'Utils/dateUtil'
import { localset, localget } from 'Utils/storage'
import filters from 'Utils/filter'
import { getSysParameter, queryVipParameter } from 'Utils/publicApi'


export const NOW_DATE = formatDate(new Date(), 1) // 默认出发日期 - 明天
export const RANGE = 30 // 火车票正常流程只能查询30天内即第30天
export const MIN_DATE = formatDate() // 最小可选日期 - 今天
export const MAX_DATE = formatDate(new Date(), RANGE - 1)
export const TravelVerificateType = {
  emp: '',
  12306: '12306',
  tgWy: 'TgWy',
  slzx: 'slzx'
}

const DEFAULT_STATION = {
  fromStation: '北京', //出发城市
  toStation: '上海', //到达城市
  fromStationCityId:'10119',
  toStationCityId:'10621',
  fromStationCode: 'VAP', //出发城市三字码
  toStationCode: 'SHH', //到达城市三字码
  byTrainDate: formatDate().date // 出发时间
}



/**
 * 火车票预订用例类
 */
class TrainBookInteractor {

  /**
   * 设置上一次预订的站点
   * @param {Object} payload：
   * 传入参数格式： {
   *    fromStation: '北京', //出发城市
   *    toStation: '上海', //到达城市
   *    fromStationCode: 'VAP', //出发城市三字码
   *    toStationCode: 'SHH', //到达城市三字码
   *    toStationCode: 'SHH', //到达城市三字码
   *    byTrainDate: '2000-01-01'
   *  }
   * @returns {void}
   */
  static setPrevStation (payload = {}) {
    const HISTORY_LOG = localget('_historyLog') || {}
    HISTORY_LOG.tr = HISTORY_LOG.tr || {}
    for (let row in DEFAULT_STATION) {
      // if (!payload[row]) {
      // 	throw `${row} 值为空, 设置默认查询站点失败`
      // } else {
      HISTORY_LOG.tr[row] = payload[row]||''
      // }
    }
    localset('_historyLog', HISTORY_LOG)
  }

  /**
   * 获取上一次预订的站点和时间
   * 存取在localStroage '_historyLog' 字段
   */
  static getPrevStation () {
    return new Promise((resolve, reject) => {
      const { tr: HISTORY_LOG } = localget('_historyLog') || {}
      if (HISTORY_LOG) {
        /**
                 * 如果上次预定时间小于今天，则取默认出发日期为明天
                 */
        if (HISTORY_LOG.byTrainDate < formatDate().date) {
          HISTORY_LOG.byTrainDate = formatDate(new Date(), 1).date
        }
        resolve(HISTORY_LOG)
      } else {
        getSysParameter('11605013').then(res => {
          if (res.value2) {
            var tr = JSON.parse(res.value2)
            DEFAULT_STATION.fromStation = tr.jcZdName
            DEFAULT_STATION.fromStationCode = tr.jcZdCode
            DEFAULT_STATION.toStation = ''
            DEFAULT_STATION.toStationCode == ''
            resolve(DEFAULT_STATION)
          } else {
            queryVipParameter('11605003').then(res => {
              if (res.value2) {
                var tr = JSON.parse(res.value2)
                DEFAULT_STATION.fromStation = tr.jcZdName
                DEFAULT_STATION.fromStationCode = tr.jcZdCode
                DEFAULT_STATION.toStation = ''
                DEFAULT_STATION.toStationCode == ''
                resolve(HISTORY_LOG)
              } else {
                resolve(DEFAULT_STATION)
              }
            })
          }
        })
        localset(DEFAULT_STATION)
      }
    })
  }

  /**
   * 火车票获取差旅政策详情
   * @returns {Array} 违背事项
   */
  static async getTravelPolicyDetail(minZj, trainCode, seatType) {
    try {
      if (!trainCode) {
        const { data = [] } = await api['trQuery/trBookMatchClzc']({ minZj })

        // 差旅政策code都一样的，取第一个即可
        let violateCode = ''
        if (data.length > 0) violateCode = data[0].code

        return {
          data,
          violateCode
        }
      } else {
        const { data = [] } = await api['trQuery/clzcIsWb']({ minZj, trainCode, seatType })

        return {
          wb: data.iswb
        }
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 出差申请单 选择行程的业务判断
   * @param {Voyage} voyage 出差申请单 选中的行程
   */
  static voyageValid (voyage) {
    if(voyage.routeStatus == 3){
      throw {
        type: 'confirm',
        errMessage: '该行程已预订，是否继续预订？'
      }
    }
  }

  /**
   * 出差申请单 选中的行程的数据清洗
   * @param {Ccsqd} ccsqd 出差申请单
   * @param {Voyage} voyage 出差申请单 选中的行程
   * @param {String} isChangeDateRange 根据出差申请单预订时可更改出行日期 日期修改范围为前后
   */
  static voyageInfoTranslator (ccsqd, voyage, isChangeDateRange) {
    const byTrainDate = voyage.departDate

    const fromStation = voyage.departAirportName || voyage.departCityName
    const fromStationCode = voyage.departAirport
    const toStation = voyage.arriveAirportName || voyage.arriveCityName
    const toStationCode = voyage.arriveAirport

    let MIN = MIN_DATE.date
    let MAX = MAX_DATE.date

    if (isChangeDateRange > 0) {
      MIN = formatDate(ccsqd.dateBegin, - isChangeDateRange).date
      MAX = formatDate(ccsqd.dateEnd, isChangeDateRange).date
    }

    const travelerList = voyage.cxrId.split(',').map(id => {
      return ccsqd.personList.filter(item => {
        return id == item.contactsId || id == item.personId || id == item.empId
      })
    }).flat() // 平铺数组

    return {
      byTrainDate,
      fromStation, fromStationCode,
      toStation, toStationCode,
      MIN_DATE: MIN,
      MAX_DATE: MAX,
      travelerList
    }
  }

  /**
   * 火车票查询参数验证
   * @returns {void}
   */
  static validSearchParams(params, serviceCtrl, travelerList) {
    // 每次搜索前获取一次当前日期
    let now = formatDate(new Date()).date

    // 非空校验
    if(serviceCtrl.isShowCcsqd && !params.Ccsqd.ccsqdId) {
      throw '请选择出差申请单'
    }
    if(serviceCtrl.showtips && serviceCtrl.isShowCxr && !travelerList.length) {
      throw '请选择出行人'
    }
    if(!params.fromStation) {
      throw '请选择出发城市'
    }
    if(!params.toStation) {
      throw '请选择到达城市'
    }
    if(params.fromStationCode === params.toStationCode) {
      throw '出发到达城市不能相同'
    }
    if(params.byTrainDate < now) {
      throw '您的行程日期已过期,你可以选择新的日期预订！'
    }
  }

  /**
   * 火车票列表查询
   */
  static async getTrainList(params) {

    try {
      const { data = {} } = await api['trQuery/trSearch']({
        ...params,
        needTrainType: params.needTrainType ? 'G,D' : ''
      })

      const trainList = data.trainList || []
      const feeList = data.feeList || []
      const supplier = feeList.find(fee => fee.prodType == 1) || {}
      const offline = feeList.find(fee => fee.prodType == 9) || {}
      const tgOffline = feeList.find(fee => fee.prodType == 6) || {}
      const slpOffline = feeList.find(fee => fee.prodType == 12) || {}


      return {
        trainList: trainList.map(train => new Train(train, params.byTrainDate)),
        feeList,
        supplierCode: supplier.compCode || '',
        supplierId: supplier.compId || '',
        supplierName: supplier.compName || '',
        sellServiceCharge: params.tripType == 1 ? (supplier.feeB || 0) : (supplier.feeP || 0),
        offline_sellServiceCharge: params.tripType == 1 ? (offline.feeB || 0) : (offline.feeP || 0),
        tgOffline_sellServiceCharge: params.tripType == 1 ? (tgOffline.feeB || 0) : (tgOffline.feeP || 0),
        slp_sellServiceCharge: params.tripType == 1 ? (slpOffline.feeB || 0) : (slpOffline.feeP || 0),
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 火车票列表页获取前一天的日期
   */
  static getPrevDay(byTrainDate, MIN_DATE) {
    /* 如果当前查询日期是当天或小于当天 则不能再查前一天  */
    if (byTrainDate <= formatDate(new Date()).date || byTrainDate <= MIN_DATE) {
      throw '您选的日期在可售范围之外！'
    }

    // if (trainSearchInfo.isChangedate > 0 && trainSearchInfo.isChangerange > 0) {
    // 	if(c < minDay.dat || c > maxDay.dat) {
    // 		mui.alert('您当前按申请单行程预订，如果需要修改出行日期，请走变更流程！')
    // 		return false
    // 	}
    // } else if (trainSearchInfo.isChangedate == 0) {
    // 	if(c < tkccsqd.dateBegin || c > tkccsqd.dateEnd) {
    // 		mui.alert('您当前按申请单行程预订，如果需要修改出行日期，请走变更流程！')
    // 		return false
    // 	}
    // }

    return formatDate(byTrainDate, -1)
  }

  /**
   * 火车票列表页获取后一天的日期
   */
  static getAfterDay(byTrainDate, MAX_DATE) {
    if (byTrainDate >= MAX_DATE) {
      throw '您选的日期在可售范围之外！'
    }

    return formatDate(byTrainDate, 1)
  }

  /**
   * 选择车次的时候 现在距离出发时间的验证
   * @param {train: Train} train 火车车次信息
   */
  static validTrain(train) {
    if (
    /**
     * 判断车次日期和现在日期
     * 大于一天直接进入列出详情页
     */
      getDiffDays(formatDate().date, train.byTrainDate) === 0
    ) {
      let diffMinutes = getDiffMinutes(trimStrTimehm(), `${train.byTrainDate} ${train.startTime}`)

      if (diffMinutes < 120 && diffMinutes > 30) {
        throw {
          type: 'confirm',
          errMessage: '本次预订的车次距发车时间不足2小时，确认预订吗？'
        }
      } else if (diffMinutes <= 30) {
        throw {
          type: 'alert',
          errMessage: '您本次预订的车次距开车时间不足 30 分钟，请到车站办理购票手续。'
        }
      }
    }
  }

  /**
   * 获取是否开启火车票资源参数
   */
  static async getOfflineBook () {
    let IS12306Book = false,
      ISofflineBook = false,
      ISTgOfflineBook = false,
      ISSlpOfflineBook = false,

      onoff_value = '0,0,0,0',
      offline_title = '',
      offline_label = '',
      offline_tips = '',
      offline_icon = '',

      tgOffline_title = '',
      tgOffline_label = '',
      tgOffline_icon = '',

      //商旅票
      slp_title = '',
      slp_label = '',
      slp_icon = ''

    const { value1 } = await queryVipParameter('11603001')
    const { data } = await api['common/getParListByCodes']({ codes: '11603008,11603009,11603010,11603011,11603012,11603014,11603015' })
    // 企业参数设置过才会有值
    if (value1) {
      onoff_value = value1
    }
    IS12306Book = onoff_value.split(',')[0] === '1'
    ISTgOfflineBook = onoff_value.split(',')[1] === '1'
    ISofflineBook = onoff_value.split(',')[2] === '1'
    ISSlpOfflineBook = onoff_value.split(',')[3] === '1'

    offline_tips = data[0].value1
    offline_title = data[1].value1
    offline_label = data[1].value2
    offline_icon = data[2].value1

    tgOffline_title = data[3].value1
    tgOffline_label = data[3].value2
    tgOffline_icon = data[4].value1

    slp_title = data[5].value1
    slp_label = data[5].value2
    slp_icon = data[6].value1

    // 没设置过取系统参数

    return {
      IS12306Book,
      ISofflineBook,
      ISTgOfflineBook,
      ISSlpOfflineBook,
      offline_title,
      offline_label,
      offline_tips,
      offline_icon,
      tgOffline_title,
      tgOffline_label,
      tgOffline_icon,
      slp_title,
      slp_label,
      slp_icon
    }
  }

  /**
   * 获取上一次登录的12306账号
   */
  static async getLast12306Account () {
    const { data = {} } = await api['trQuery/getNewest']()

    if (data && data.userName && data.password) {
      return {
        trainAccount: data.userName,
        password: data.password
      }
    }
    return {}
  }

  /**
   * 调用本地数据库的核验乘车人
   * 核验联系信息是否通过
   * @param {travelerList: Traveler[]} travelerList 乘车人
   * @param {isLocal: Boolean} 是否请求本地核验，只有选人的时候调
   */
  static async verificate (travelerList, isLocal) {
    try {
      const indexs = []
      const CONN_API = isLocal ? api['trQuery/checkLocalHytgry'] : api['trQuery/getCheckResult']
      const passengerList = travelerList.filter((psg, i) => {
        if (psg.checkCode != '1' && psg.psgType != '2') {
          indexs.push(i)
          return true
        }
      }).map(psg => {
        return {
          passengerName: filters.getName(psg),
          idType: psg.cardType ? psg.cardType : '1',
          idCode: filters.getIdNumber(psg),
          phoneNumber: psg.phoneNumber,
          email: psg.email
        }
      })

      if (passengerList.length == 0) return { checkCodes: [] }
      const { data = {} } = await CONN_API({ passengerList })

      return {
        indexs,
        checkCodes: data.passengerList.map(psg => psg.checkCode)
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 前往核验手机号，获取验证码
   * 返回验证码，验证已通过返回 'success'
   * @param {traveler: Traveler} psg 乘车人
   */
  static async getVerificateCode (psg) {
    let passengerList = [{
      passengerName: filters.getName(psg),
      idType: psg.cardType,
      idCode: filters.getIdNumber(psg),
      phoneNumber: psg.phoneNumber,
      email: psg.email,
      expiryDate: psg.expiryDate,
      passengerType: psg.psgType,
      nation: psg.nation,
      sex: psg.sex,
      born: psg.born
    }]

    const { data = {} } = await api['trQuery/checkRyxx']({
      passengerList,
      reCheck: psg.checkCode == '1' ? 1 : 0
    })
    const psgInstance = data.passengerList[0]

    if (psgInstance.checkCode === '2') {
      return psgInstance.yzm
    } else if (psgInstance.checkCode === '1') {
      return 'success'
    }else if (psg.checkCode == '1' && psgInstance.checkCode === '0') {
      return '0'
    } else {
      throw '您的身份信息核验未通过，请先核实身份信息'
    }
  }

  /**
   * 火车票订单填写订单信息验证
   * 验证订单信息与已有订单是否存在 "行程冲突" "重复订单" "临近车次"
   * @param {order: TrainOrder} order 火车票订单
   * @param {insuranceList: Insurance[]} insuranceList 选中的保险列表
   */
  static async validOrder (order) {
    try {
      if (order.passengerList.length <= 0) throw '请选择出行人'
      if (order.passengerList.length > 5) throw '最多只能选择5个出行人'
      if (!order.linkTel) throw '请添加联系人手机号'

      const { data = {} } = await api['trQuery/validOrder']({
        ...order,
        toDateTime: `${order.toDate} ${order.toTime}`,
        passengerList: order.passengerList.map(psg => {
          return {
            idCode: psg.idCode,
            passengerName: psg.passengerName
          }
        })
      })

      return {
        data
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 火车票下单
   * @param {order: TrainOrder} order 火车票订单
   * @param {insuranceList: Insurance[]} insuranceList 选中的保险列表
   */
  static async book (order, insuranceList) {
    try {
      const { data = {} } = await api['trQuery/trBookOrder'](order)

      // 火车票预订成功后 保险下单
      await InsuranceInteractor.book(
        { ...data, ...order, cplx: $dict.PRO_TYPE.tr }, insuranceList
      )

      return {
        data
      }
    } catch (error) {
      throw error
    }
  }

}

export default TrainBookInteractor
